import Vue from 'vue';

export const tutorialHelper = { // eslint-disable-line
  bind: (el) => {
    Vue.nextTick(() => {
      const isIE = document.documentMode || /Edge/.test(navigator.userAgent);

      if (isIE) {
        const textBlocks = el.getElementsByTagName('p');
        el.style.alignItems = 'flex-end';

        if (textBlocks[0].offsetHeight > textBlocks[1].offsetHeight) {
          textBlocks[1].style.height = `${textBlocks[0].offsetHeight}px`;
        } else {
          textBlocks[0].style.height = `${textBlocks[1].offsetHeight}px`;
        }
      }
    });
  },
};
